import type { CreateInterestPayload, Interest } from '../entities/interest.entity'
import type { InterestRepository } from '../repositories/interest_repository'

export class CreateInterestUseCase {
  constructor(private readonly repository: InterestRepository) {}

  execute(payload: CreateInterestPayload): Promise<Interest> {
    return this.repository.create(payload)
  }
}
